import { Swiper, SwiperSlide } from 'swiper/react'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
// eslint-disable-next-line no-unused-vars
import { LazyBackgroundImage } from 'components/share/withImages'
import Image from 'next/image'

import styles from './user-quote.module.scss'

export default function Index (props) {
  const [imageUrl, setImageUrl] = useState('/static/images/testimonials/user-quote2.png')
  const [swiperRef, setSwiperRef] = useState()
  const bgImage = 'url(' + imageUrl + ') top left/100% auto no-repeat #000000'
  const params = {
    loop: true,
    spaceBetween: 50,
    loopAdditionalSlides: 3,
    navigation: {
      nextEl: '.arrow-next',
      prevEl: '.arrow-prev'
    },
    breakpoints: {
      320: {
        direction: 'vertical',
        slidesPerView: 3,
        spaceBetween: 0
      },
      768: {
        direction: 'horizontal',
        slidesPerView: 3,
        spaceBetween: 10
      }
    }
  }

  const handlePrevious = () => {
    swiperRef?.slidePrev()
  }

  const handleNext = () => {
    swiperRef?.slideNext()
  }

  const sliders = [
    {
      text: 'I’ve lost over 75lbs (and counting) as a student of Mike Dolce’s.  I have a second chance to live my life.',
      author: '– Bonnie Wilson'
    },
    {
      text: 'I lost 50lbs in about 2 months with The Dolce Diet.  Mike knows what you need and he keeps it natural.',
      author: '– Joseph Kuhn'
    },
    {
      text: 'The Dolce Diet helped me lose 58 pounds and changed my life … thank you so much mike.',
      author: '– Conor Walsh'
    },
    {
      text:
        '"Using The Dolce Diet and exercising, I have LOST 160 pounds!"',
      author: '– Alton F'
    },
    {
      text:
        '"Everything in my life has improved."',
      author: '– Anne W'
    },
    {
      text:
        '"Results are instant and I\'m in love with the food."',
      author: '– Ben R'
    },
    {
      text:
        '"I am now more confident in myself"',
      author: '– Christina B'
    },
    {
      text:
        '"I was finally able to get the body I desired"',
      author: '– Dan C'
    },
    {
      text:
        '"I lost 45 pounds!"',
      author: '– Daniel G'
    },
    {
      text:
        '"Mike Dolce changed my life!"',
      author: '– Ed K'
    },
    {
      text:
        '"I used to starve myself. With 3W2S I can eat all the time and my body never looked better"',
      author: '– Emma K'
    },
    {
      text:
        '"The Dolce Diet saved my life"',
      author: '– Greg Y'
    },
    {
      text:
        '"Once I started, I never look back"',
      author: '– Jenny L'
    }
  ]
  useEffect(() => {
    if (props.bgUserQuote) {
      setImageUrl(props.bgUserQuote)
    }
    LazyBackgroundImage({ src: props.bgUserQuote, alt: 'Placeholder', loaded: props.bgUserQuote !== undefined })
  }, [props])
  return (
    <section className={styles['user-quote']}>
      <div className='wrapper lazy-background' style={{ background: bgImage }}>
        <div className={`col-12 col-md-10 me-auto ms-auto ${styles['user-quote__wrap-content']}`}>
          <h3 className={styles['user-quote__title']}>
            <Image layout="fill" src='/static/images/testimonials/icon-title.svg' className={['d-block', styles['title-image']].join(' ')} alt={'"'} />
            What Our dolce dieters are saying
          </h3>
          <div className={styles['user-quote__slider-wrapper']}>
            <div className="arrow-prev swiper-button-prev" onClick={handlePrevious}>
              <Image className={styles['arrow-image']} layout="fill" src="/static/images/testimonials/arrow-prev.png" alt={'<'} />
            </div>
            <div className="arrow-next swiper-button-next" onClick={handleNext}>
              <Image className={styles['arrow-image']} layout="fill" src="/static/images/testimonials/arrow-next.png" alt={'>'} />
            </div>
            <Swiper {...params} onSwiper={setSwiperRef} className={styles['user-quote__slider-quote']}>
              {sliders.map((slide, index) => {
                return (
                  <SwiperSlide
                    virtualIndex={index}
                    key={index}
                    className='card no-background no-border'
                  >
                    <div className='caption'>
                      <p className={styles['user-quote__text']} dangerouslySetInnerHTML={{ __html: slide.text }}></p>
                      <span className={styles['user-quote__author']}>{slide.author}</span>
                    </div>
                  </SwiperSlide>
                )
              })}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  )
}

Index.propTypes = {
  bgUserQuote: PropTypes.string
}
